import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray"; //@ts-check

/**
 * @param {import('../logic/types').EcrionFormRepeatingField} repeating
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {Array<string>} An array with all visible fields in repeating
 */

var findVisibleFieldsInRepeating = function findVisibleFieldsInRepeating(repeating, state) {
  // because we have some custom validation for repeating (like min and max number of items)
  // we apply validation also for this kind of field, so we add it to result
  var result = [repeating.id];
  if (!repeating.children) return result;
  var values = state.data && state.data[repeating.id];
  if (!values || !values.length) return result;
  var containers = state.layout.containers;
  values.forEach(function (value) {
    // a repeating field will generate a container for each value
    var containerId = "".concat(repeating.id, "_").concat(value);
    result.push.apply(result, _toConsumableArray(findVisibleFields(containers[containerId], state)));
  });
  return result;
};
/**
 * @param {import("../layout/types").EcrionFormContainerLayout} container
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {Array<string>} An array with all visible fields in the orther they appear in the layout
 */


var findVisibleFields = function findVisibleFields(container, state) {
  var fields = [];
  var rows = container.rows;
  if (!rows || !rows.length) return fields;
  rows.forEach(function (row) {
    row.fields.forEach(function (fieldLayout) {
      var fieldId = fieldLayout.id;
      var field = state.fields[fieldId];
      if (!field) return;

      if (field.type === 'repeating') {
        var repeatingFields = findVisibleFieldsInRepeating(field, state);
        repeatingFields.forEach(function (id) {
          return fields.push(id);
        });
      } else if (state.layout.containers[fieldId]) {
        var fieldContainer = state.layout.containers[fieldId];
        var innerFields = findVisibleFields(fieldContainer, state);
        innerFields.forEach(function (id) {
          return fields.push(id);
        });
      } else {
        fields.push(fieldId);
      }
    });
  });
  return fields;
};

export default {
  findVisibleFields: findVisibleFields
};